import React from 'react'
import { type InputPhoneProps } from '@dostavkee/web-ui'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { toast } from 'sonner'

import { ROLES } from '@/entities/auth'
import { getCheckLimit, RecruitmentLimitToastError } from '@/entities/recruitment'
import { CreateRecruitmentPage } from '@/pages/create-recruitment-page'

type CreateRecruitmentSearch = {
    iso?: InputPhoneProps['iso']
}

export const Route = createFileRoute('/_dashboard/recruitment/create')({
    component: CreateRecruitmentPage,
    onEnter: () => {
        document.title = `Taxoparkee - Добавление водителя`
    },
    beforeLoad: async ({ context }) => {
        if (!context.auth.hasAnyRole([ROLES.superManager, ROLES.recruiter])) {
            throw redirect({
                to: '/support',
            })
        }

        const { isReachedLimit, formattedLimitCount, formattedLimitPeriod } = await getCheckLimit()

        if (isReachedLimit) {
            toast.error(
                <RecruitmentLimitToastError
                    formattedLimitCount={formattedLimitCount}
                    formattedLimitPeriod={formattedLimitPeriod}
                />,
                {
                    duration: 5000,
                }
            )
            throw redirect({
                to: '/recruitment',
                search: {
                    page: 1,
                },
            })
        }
    },
    validateSearch: (search: Record<string, unknown>): CreateRecruitmentSearch => {
        return {
            iso: search.iso as InputPhoneProps['iso'],
        }
    },
})
